export function createEl(option:CreateElOptionsFragment):DocumentFragment;
export function createEl(option:CreateElOptionsHtmlElement):HTMLElement;
export function createEl({
    el="div", text=undefined, attributes={}, classes=[], dataset={}, children=[], id=undefined,
    style={}, transform=undefined, src=undefined, parent=undefined, events={}, href=undefined,
  }: CreateElOptions) {

  let nodeEl:HTMLElement|DocumentFragment;
  let fragment:DocumentFragment|null = null;
  let htmlElement:HTMLElement|null = null;

  if (el === 'fragment' || el === null) {
    fragment = document.createDocumentFragment();
    nodeEl = fragment;
  } else {
    htmlElement = document.createElement(el);
    nodeEl = htmlElement;
  }

  if (text) nodeEl.textContent = text;
  if (transform) style.transform = transform;
  if (src) attributes.src = src;
  if (id && htmlElement) htmlElement.id = id;
  if (href && htmlElement) htmlElement.setAttribute('href', href);

  if (htmlElement) {
    for (const attributeName of Object.keys(attributes)) {
      const attributeValue = attributes[attributeName];
      if (attributeValue === true) {
        htmlElement.setAttribute(attributeName, "");
      } else if (attributeValue === false) {
        htmlElement.removeAttribute(attributeName);
      } else {
        htmlElement.setAttribute(attributeName, attributeValue);
      }
    }

    for (const propertyName of Object.keys(style)) {
      htmlElement.style.setProperty(propertyName, style[propertyName]);
    }

    for (const propertyName of Object.keys(dataset)) {
      htmlElement.dataset[propertyName] = dataset[propertyName];
    }

    for (let propertyName of Object.keys(events)) {
      let propertyValue = events[propertyName];
      if (!Array.isArray(propertyValue)) propertyValue = [propertyValue];
      propertyValue.forEach(listener => (htmlElement as HTMLElement).addEventListener(propertyName, listener));
    }

    htmlElement.classList.add(...classes);
  }

  const childEls = children.map(child => {
    if (typeof child === 'string') {
      return document.createTextNode(child);
      // return child; // HTMLElement.append() automatically creates text nodes for plain stings
    } else if (child instanceof HTMLElement) {
      return child;
    } else {
      return createEl(child as CreateElOptionsHtmlElement);
    }
  });
  nodeEl.append(...childEls);

  if (parent && typeof(parent) === 'string') {
    const parentEl = document.querySelector(parent);
    if (!parentEl) throw new Error(`Could not append created element to '${parent}' because it was not found in the DOM`);
    parentEl.appendChild(nodeEl);
  }
  if (parent && typeof(parent) === 'object') {
    parent.appendChild(nodeEl);
  }

  if (el === 'fragment' || el === null) return fragment;
  else return htmlElement;
}

export type CreateElOptions = CreateElOptionsFragment | CreateElOptionsHtmlElement;
export interface CreateElOptionsFragment extends CreateElOptionsBase {
  el: 'fragment'|null,
  parent?:HTMLElement|string,
  events: undefined,
}

export interface CreateElOptionsHtmlElement extends CreateElOptionsBase {
  el?: string,
  parent?:HTMLElement|string,
}

export interface CreateElOptionsBase {
  el?:string|null,
  id?:string,
  text?:string,
  attributes?:{[key:string]: string|boolean},
  classes?:string[],
  dataset?:{[key:string]: string},
  children?:(CreateElOptionsBase|string|HTMLElement)[],
  style?:{[key:string]: string},
  transform?:string,
  src?:string,
  href?:string,
  events?:{[key:string]: EventListenerOrEventListenerObject|EventListenerOrEventListenerObject[]},
}
